import axiosInstance from './axios';

export const getProducts = async () => {
  const response = await axiosInstance.get('/products');
  // Handle the nested response structure: { success, count, data }
  if (response.data && response.data.success && response.data.data) {
    return response.data.data;
  }
  return response.data;
};

export const getProductById = async (id) => {
  const response = await axiosInstance.get(`/products/${id}`);
  // Handle the nested response structure
  if (response.data && response.data.success && response.data.data) {
    return response.data.data;
  }
  return response.data;
};
